import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class UserPermissionVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUserpermissionCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUserpermissionCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUserpermissionReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUserpermissionRead,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUserpermissionDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUserpermissionDelete,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationUserpermissionUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationUserpermissionUpdate,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationUserpermissionCreateany,
        PermissionAttributesEnum.GlobalOperationUserpermissionUpdateany,
        PermissionAttributesEnum.GlobalOperationUserpermissionDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationUserpermissionCreate,
        PermissionAttributesEnum.ContextOperationUserpermissionUpdate,
        PermissionAttributesEnum.ContextOperationUserpermissionDelete,
      ],
    });
  };
}
